import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged, map, Observable, shareReplay } from 'rxjs';

export const BOOTSTRAP_BREAKPOINTS = {
  sm: '(max-width: 575.98px)',
  md: '(max-width: 767.98px)',
  lg: '(max-width: 991.98px)',
  xl: '(max-width: 1199.98px)',
  xxl: '(max-width: 1399.98px)',
};

@Injectable({
  providedIn: 'root',
})
export class BreakpointObserverService {

  public isScreenSmall$: Observable<boolean> = new BehaviorSubject(false).asObservable();

  constructor(private breakpointObserver: BreakpointObserver) {

    this.isScreenSmall$ = this.breakpointObserver
      .observe(BOOTSTRAP_BREAKPOINTS.lg)
      .pipe(
        map((state: BreakpointState) => state.matches),
        distinctUntilChanged(),
        shareReplay({ bufferSize: 1, refCount: true })
      );
  }
}